import { BottomSheet } from 'doctornow-design-system';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const DietGuideBottomSheet = ({ isOpen, onClose }: Props) => {
  return (
    <BottomSheet
      type='single'
      title='다이어트 진료 안내'
      description='다이어트 약물 처방은 비대면으로 가능해요!'
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
      buttons={[
        {
          label: '확인했어요',
          variant: 'primary',
          onClick: onClose,
        },
      ]}
    >
      <div className='flex justify-center'>
        <img
          src='/images/diet_diagnosis_bottom_sheet_guide.png'
          alt='diet guide'
          className='h-[160px] w-[312px] object-contain'
        />
      </div>
    </BottomSheet>
  );
};

export default DietGuideBottomSheet;
